<template>
  <div id="Cookies" class="Cookies" v-if="!this.hasCookies">
    <div class="Cookies-content"> 
        <span class="Cookies-content-description">{{$t('cookies.description')}}</span>

        <router-link :to="{ path: '/politica-de-privacidade'}" class="Cookies-content-ancor">Política de Privacidade</router-link>
    </div>
     <div @click="setCookie" class="Cookies-button">{{$t('cookies.accept')}}</div>
  </div>
</template>

<script>
    import { eventBus } from './event.js';

    export default {
        data() {
            return {
                hasCookies: this.$cookies.get('cookies-accept-lgpd')
            }
        },
        methods: {
            pathPdf(){
                return `/politica-de-privacidade`
            },
            setCookie(data = "accepted"){
                this.$cookies.set("cookies-accept-lgpd", data);
                eventBus.$emit('cookiesSet', data);
            }
        },
        created() {
            eventBus.$on('cookiesSet', (token) => this.hasCookies = token);
        }
    };
</script>


<style lang="scss">
    .Cookies {
        left: 50%;
        bottom: 5px;
        width: 100%;
        display: flex;
        position: fixed;
        max-width: 856px;
        min-height: 50px;
        margin-left: -428px;
        border-radius: 4px;
        align-items: center;
        padding: 8px 16px 12px;
        background-color: #FFFFFF;
        justify-content: space-around;
        border-bottom: 5px solid #3CBCE6;
        box-shadow: 0px 2px 12px -2px;
        &-content {
            &-description, &-ancor{
                font-size: 12px;
                font-weight: 100;
            }

            &-description {
                color: #222831;
            }

            &-ancor { 
                color: #3ab8e8;
                text-decoration: underline;
            }
        }

        &-button {
            padding: 8px 20px;
            font-size: 12px;
            font-weight: normal;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-left: 16px;
            border-radius: 4px;
            background-color: #3CBCE6;
            color: white;
            height: 32px;
            width: 112px;
            min-width: 112px;
            cursor: pointer;
        }
    
    }

    @media (max-width: 640px) {
		.Cookies {
            left: 0;
            margin-left: 0px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/Cookies/Cookies.vue